<template>
    <zen-slide-in
        :isOpen="isOpen"
        :title="'Teams: ' + userName"
        @close="$emit('close')"
    >
        <template #body>
            <div class="space-y-6">
                <!-- Add to team -->
                <div>
                    <label
                        for="add-team-select"
                        class="block text-sm font-medium text-taupe-900 mb-2"
                    >
                        Add to team
                    </label>
                    <div class="flex gap-2">
                        <zen-auto-complete
                            class="flex-1"
                            input-id="add-team-select"
                            :model-value="modelValue"
                            @update:model-value="
                                (value) => $emit('update:modelValue', value)
                            "
                            :search="searchAvailableTeams"
                            option-label="label"
                            option-value="ulid"
                            placeholder="Select a team..."
                            show-dropdown-button
                            :min-length="0"
                            data-testid="add-team-select"
                        />
                        <zen-button
                            variant="primary"
                            size="small"
                            :disabled="!modelValue"
                            :processing="adding"
                            @click="$emit('add')"
                            data-testid="add-team-button"
                        >
                            Add
                        </zen-button>
                    </div>
                </div>

                <!-- Current teams -->
                <div>
                    <h3 class="text-sm font-medium text-taupe-900 mb-3">
                        Current teams
                    </h3>
                    <ul
                        v-if="teams.length > 0"
                        class="divide-y divide-taupe-100"
                    >
                        <li
                            v-for="team in teams"
                            :key="team.ulid"
                            class="flex items-center justify-between py-2"
                            :data-testid="'team-row-' + team.ulid"
                        >
                            <span class="text-sm text-taupe-900">{{
                                team.name
                            }}</span>
                            <button
                                @click="$emit('remove-team', team.ulid)"
                                class="text-taupe-400 hover:text-red-500 transition-colors"
                                title="Remove from team"
                                :data-testid="'remove-team-' + team.ulid"
                            >
                                <svg
                                    class="h-5 w-5"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                            </button>
                        </li>
                    </ul>
                    <p v-else class="text-sm text-taupe-400">
                        Not a member of any teams.
                    </p>
                </div>
            </div>
        </template>
        <template v-slot:buttons>
            <zen-button
                variant="secondary"
                size="medium"
                @click="$emit('close')"
            >
                Close
            </zen-button>
        </template>
    </zen-slide-in>
</template>

<script>
export default {
    name: 'ManageUserTeamsSlideIn',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        userName: {
            type: String,
            default: '',
        },
        teams: {
            type: Array,
            required: true,
        },
        modelValue: {
            type: String,
            default: '',
        },
        searchAvailableTeams: {
            type: Function,
            required: true,
        },
        adding: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'add', 'remove-team', 'update:modelValue'],
}
</script>
